import { toEnglishDigits } from "@/utils/helpers";

/**
 * A sign-in contact with most of it hidden, such as `moh…88@gmail.com` or `+9665…12`, matching the server's
 * `App\Services\Auth\SignInHint`, so a shared computer reminds its owner which account they use without revealing it.
 */
export const maskEmail = (email: string): string => {
  const [local = "", domain = ""] = email.trim().toLowerCase().split("@");
  const characters = Array.from(local);
  const length = characters.length;

  const masked =
    length >= 6
      ? `${characters.slice(0, 3).join("")}…${characters.slice(-2).join("")}`
      : length >= 3
        ? `${characters[0]}…${characters[length - 1]}`
        : `${characters[0] ?? ""}…`;

  return `${masked}@${domain}`;
};

export const maskMobile = (mobile: string): string => {
  let digits = toEnglishDigits(mobile).replace(/\D+/g, "");

  if (digits.startsWith("00")) {
    digits = digits.slice(2);
  } else if (/^05\d{8}$/.test(digits)) {
    digits = `966${digits.slice(1)}`;
  } else if (/^5\d{8}$/.test(digits)) {
    digits = `966${digits}`;
  }

  if (digits.length < 6) {
    return `…${digits.slice(-2)}`;
  }

  // The country code and first digit say which kind of number it is; the last two let its owner recognise it.
  const prefixLength = digits.length > 9 ? digits.length - 8 : 1;

  return `+${digits.slice(0, prefixLength)}…${digits.slice(-2)}`;
};
